export default Object.freeze({
  waysOfConnection: 0,
  connectionAcrossTaxAuthority: 1,
  connectionAcrossEsia: 2,
  connectionAcrossCertificate: 3,
  passwordRecovery: 4,
  incorrectData: 5,
  functionality: 6,
  payments: 7,
  certificate: 8,
  personalData: 9,
});
